import { render } from "./DataTableLoading.vue?vue&type=template&id=16aa23f0"
import script from "./DataTableLoading.vue?vue&type=script&lang=js"
export * from "./DataTableLoading.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__